module.exports = __webpack_public_path__ + "static/media/boy-23.7326a003.svg";